import Box from '@elementor/ui/Box';
import Chip from '@elementor/ui/Chip';
import Typography from '@elementor/ui/Typography';
import PropTypes from 'prop-types';
import { useScannerWizardContext } from '@context/scanner-wizard-context';
import { useAnalytics } from '@hooks/use-analytics';
import GoogleAnalyticsEvent, {
	EVENT_SECTIONS,
	EVENT_TYPES,
} from '@hooks/use-analytics/google-analytics-event';
import { StyledButton, StyledButtonContainer } from '@styles/app.styles';

const BlockButton = ({ title, count, block }) => {
	const { setOpenedBlock } = useScannerWizardContext();
	const { sendEvent } = useAnalytics();

	const handleClick = () => {
		setOpenedBlock(block);

		sendEvent(
			new GoogleAnalyticsEvent()
				.setType(EVENT_TYPES.UI)
				.setSection(EVENT_SECTIONS.SIDEBAR)
				.setElementName(`${title.toLowerCase()} accordion`)
				.setOutcome(`opening ${title.toLowerCase()}`)
				.setEnglishText(title)
				.setLevelOne(count),
		);
	};

	return (
		<StyledButton
			variant="outlined"
			color="secondary"
			size="large"
			fullWidth
			onClick={handleClick}
		>
			<StyledButtonContainer elevation={0} variant="elevation" color="default">
				<Box display="flex" alignItems="center" gap={0.5}>
					<Typography variant="subtitle2" as="h4" color="text.primary">
						{title}
					</Typography>

					<Chip label={count} color="error" variant="standard" size="tiny" />
				</Box>
			</StyledButtonContainer>
		</StyledButton>
	);
};

BlockButton.propTypes = {
	title: PropTypes.string.isRequired,
	count: PropTypes.number.isRequired,
	block: PropTypes.string.isRequired,
};

export default BlockButton;
